import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import RouteLink from 'flow/components/ui-components/RouteLink';
import { routes } from 'flow/types/routes';
import {
    CTI_LIST_SETTINGS_VALUE_LABELS,
    CTISettings,
    CTIListSettingKey,
} from 'flow/types/CTISettings';

type Props = {
    setting: CTISettings;
    propertyName: CTIListSettingKey;
};

const CtiSettingList = ({ setting, propertyName }: Props) => {
    const { i18next } = useAppContext();

    let routeTo;
    switch (propertyName) {
        case 'showOnLoad':
            routeTo = routes['settings.cti-settings.showonload'];
            break;
        case 'openOnCall':
            routeTo = routes['settings.cti-settings.openoncall'];
            break;
        case 'openOnAnswer':
            routeTo = routes['settings.cti-settings.openonanswer'];
            break;
        default:
            routeTo = routes['settings.cti-settings'];
            break;
    }

    const val = setting[propertyName].value;
    const description =
        typeof val === 'string' &&
        val in CTI_LIST_SETTINGS_VALUE_LABELS[propertyName]
            ? i18next.t(CTI_LIST_SETTINGS_VALUE_LABELS[propertyName][val])
            : '';

    return (
        <RouteLink to={routeTo} description={description}>
            {i18next.t(setting[propertyName].label)}
        </RouteLink>
    );
};

export default CtiSettingList;
